import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// import './index.css'; // import from html for faster styles
import App from './App'

const container = document.getElementById('root')
const root = createRoot(container) // createRoot(container!) if you use TypeScript

// Concurrent
root.render(
  <StrictMode>
    <App />
  </StrictMode>
)
